import axios from "../axios";
import { IAppMenuDelParams, IAppMenuFindAllData, IAppMenuItem, IAppMenuSelectAppMenuTreeData } from "./app.types";

/**
 * 添加菜单 
 */
export function appMenuAdd(params: IAppMenuItem) {
    return axios({
        method: 'post',
        url: '/app/menu/add',
        data: params
    })
}

/**
 * 删除菜单 
 */
export function appMenuDel(params: IAppMenuDelParams) {
    return axios({
        method: 'delete',
        url: `/app/menu/delete/${params.id}`,
    })
}

/**
 * 编辑菜单 
 */
export function appMenuEdit(params: IAppMenuItem) {
    return axios({
        method: 'post',
        url: '/app/menu/edit',
        data: params
    })
}

/**
 * 查找所有菜单 
 */
export function appMenuFindAll() {
    return axios<IAppMenuFindAllData>({
        method: 'get',
        url: '/app/menu/findAll',
    })
}

/**
 * app菜单查找
 */
export function appMenuSelectAppMenuTree(parentCompanyId) {
    return axios<IAppMenuSelectAppMenuTreeData>({
        method: 'get',
        url: `/app/menu/selectAppMenuTree/${parentCompanyId}`
    })
}
